import React, { useState, useEffect } from "react";
import { CrudSkusRecord } from "../../Components/Cruds/CrudSkusRecord";
import { CrudReceptionsRecord } from "../../Components/Cruds/CrudReceptionsRecord";
import { CrudQualitysReceptionsRecord } from "../../Components/Cruds/CrudQualitysReceptionsRecord";
import { CrudDocManagementsRecord } from "../../Components/Cruds/CrudDocManagementsRecord";
import { CrudServiceFee } from '../../Components/Cruds/CrudServiceFee';
import { getUserPermissionsByUserEmail } from "../../api/usersModule/getters";
import { NotFoundPage } from "../NotFoundPage/NotFoundPage";
import { LoadingPage } from "../LoadingPage/LoadingPage";
import { useUserContext } from "../../utils/Contexts/UserContext";

const moduleName = "Informes";

export const ReportsPage = () => {
  const [userPermissions, setUserPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const user = useUserContext();

  const getPermissions = async () => {
    setLoading(true);

    let permissions = {
      Consultar: false,
      Crear: false,
      Editar: false,
      Eliminar: false,
    };

    try {
      permissions = await getUserPermissionsByUserEmail(
        user.attributes["email"],
        user.attributes["custom:project"],
        moduleName
      );

      permissions["Consultar"]
        ? setUserPermissions(permissions)
        : setUserPermissions([]);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPermissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {userPermissions && userPermissions["Consultar"] ? (
        <div
          style={{
            flex: "1 1 auto",
            display: "flex",
            flexFlow: "column",
            height: "100vh",
            overflowY: "auto",
          }}
        >
          <div
            style={{
              padding: "20px 5%",
              flex: '1',
            }}
          >
            <CrudSkusRecord
              userName={user.attributes.family_name}
              permissions={userPermissions}
              project={user.attributes["custom:project"]}
            />
          </div>
          <div
            style={{
              padding: "20px 5%",
              flex: '1',
            }}
          >
            <CrudReceptionsRecord
              userName={user.attributes.family_name}
              permissions={userPermissions}
              project={user.attributes["custom:project"]}
            />
          </div>
          <div
            style={{
              padding: "20px 5%",
              flex: '1',
            }}
          >
            <CrudQualitysReceptionsRecord
              userName={user.attributes.family_name}
              permissions={userPermissions}
              project={user.attributes["custom:project"]}
            />
          </div>
          <div
            style={{
              padding: "20px 5%",
              flex: '1',
            }}
          >
            <CrudDocManagementsRecord
              userName={user.attributes.family_name}
              permissions={userPermissions}
              project={user.attributes["custom:project"]}
            />
          </div>
          <div
            style={{
              padding: "20px 5%",
              flex: '1',
            }}
          >
            <CrudServiceFee
              userName={user.attributes.family_name}
              permissions={userPermissions}
              project={user.attributes["custom:project"]}
            />
          </div>
        </div>
      ) : loading ? (
        <LoadingPage />
      ) : (
        <NotFoundPage />
      )}
    </>
  );
};
